package nl.volleyplanner.web.base.component

import kotlinx.browser.document
import kotlinx.dom.clear
import kotlinx.html.FlowContent
import kotlinx.html.TagConsumer
import kotlinx.html.classes
import kotlinx.html.div
import kotlinx.html.dom.create
import kotlinx.html.id
import nl.volleyplanner.web.base.StandaloneHTMLComponent
import nl.volleyplanner.web.lib.Offcanvas
import org.w3c.dom.HTMLElement


enum class OffcanvasPosition(val cssClass: String) {
    Start("offcanvas-start"),
    End("offcanvas-end"),
    Top("offcanvas-top"),
    Bottom("offcanvas-bottom")
}

abstract class OffcanvasComponent(
    elementId: String,
    cssClasses: Set<String> = setOf(),
    offcanvasPosition: OffcanvasPosition = OffcanvasPosition.Start,
    allowBodyScroll: Boolean = false,
    showBackdrop: Boolean = true,
    private val persistent: Boolean = false
) : StandaloneHTMLComponent() {
    private val offcanvasElement = document.create.div(classes = "offcanvas") {
        classes += offcanvasPosition.cssClass
        classes += cssClasses
        attributes["data-bs-scroll"] = "$allowBodyScroll"
        attributes["data-bs-backdrop"] = "$showBackdrop"
        id = elementId
    }

    private var bootstrapOffcanvas: Offcanvas? = null

    override fun initialize() {
        bootstrapOffcanvas = Offcanvas.getOrCreateInstance(offcanvasElement)
    }

    override fun onDispose() {
        super.onDispose()

        bootstrapOffcanvas?.dispose()

        if (!persistent) {
            offcanvasElement.parentNode?.removeChild(offcanvasElement)
        }
    }

    fun show() = bootstrapOffcanvas?.show() ?: throw IllegalStateException("[$componentId] Offcanvas not initialized")

    fun hide() = bootstrapOffcanvas?.hide() ?: throw IllegalStateException("[$componentId] Offcanvas not initialized")

    final override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        offcanvasElement.clear()
        val headerElement = consumer.div(classes = "offcanvas-header") { renderHeader() }
        val bodyElement = consumer.div(classes = "offcanvas-body") { renderBody() }

        offcanvasElement.append(headerElement, bodyElement)
        return offcanvasElement
    }

    abstract fun FlowContent.renderHeader()
    abstract fun FlowContent.renderBody()
}